import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    message,
    Tag, Space,
    Drawer,
    Row, Col, Form, Menu, Select, Modal, Input, Collapse, PageHeader, InputNumber, Spin, Empty
} from 'antd';
import {getSubordinateKpiDetail, saveSubordinateKpi, ensureSubordinateKpi, publishSubordinateKpi,} from '../../request'
import * as Icon from '@ant-design/icons';
import IconFolder from '../../public/iconfont/iconFolder'
import {withRouter} from "react-router-dom";
import TransferModal from "./TransferModal";
const { Panel } = Collapse;

class KpiDetail extends Component {
    employeeModal = React.createRef()
    surveyModal = React.createRef()
    state = {
        dataSource: [],
        dicList: {},
        SurveyQaList: [],
        columns: [],
        loading: false,
        visible: false,
        systemItem: {},
        formParam: {
            userId: this.props.id != 0 ? this.props.id : null,
        },
        total: 0,
        formDataParam: {
            name: ''
        },
        detailDrawerVisible: false,
        submitParam: {},
        userName: '',
        ensure: false
    };

    initTableDataList() {
        this.setState({loading: true});
        console.log(this.state.formParam)
        getSubordinateKpiDetail(this.state.formParam).then(res => {
            this.setState({
                loading: false,
                dataSource: res.list,
                defaultActive: res.list.map(item => item.id),
                userName: res.currentUserName || '',
                ensure: res.ensure
            })
        })
    }

    handlePushFilterValueChange = (changedValues, allValues, index) => {
        let param = this.state.dataSource
        param[index].content = allValues.content
        console.log(changedValues, allValues)
        this.setState({
            dataSource: param
        })
    }
    saveKpi = (index) => {
        saveSubordinateKpi([this.state.dataSource[index]]).then(res => {
            message.success('保存成功')
            this.initTableDataList()
        })
    }
    publishKpi = (index) => {
        publishSubordinateKpi({id: this.state.dataSource[index].id}).then(res => {
            message.success('发布成功')
            this.initTableDataList()
        })
    }
    toPerformance = (index, type) => {
        let periodId = this.state.dataSource[index].periodId
        let url = type == 'self' ? '/oa/myperformance' : `/oa/subordinate/performancedetail/${this.state.formParam.userId}`
        this.props.history.push({
            pathname: url,
            search: `?periodId=${periodId}`
        })
    }
    ensureKpi = () => {
        ensureSubordinateKpi({}).then(res => {
            message.success('确认成功')
            this.initTableDataList()
        })
    }
    setPeers = () => {
        this.employeeModal.current.handleModalOpen({userId: this.state.formParam.userId, departmentShow: false})

    }

    componentDidMount() {
        this.initTableDataList()
    }

    render() {
        const locationQuery = new URLSearchParams(window.location.search)
        const periodId = locationQuery.get('periodId')
        const {dataSource, columns, loading, detailDrawerVisible, dicList, editParam} = this.state;

        return (
            <>
                <Card title={
                    this.props.id?
                        <>
                            <span style={{marginRight:'10px',fontWeight:'bolder',cursor:'pointer'}} onClick={()=>this.props.history.go(-1)}><Icon.ArrowLeftOutlined/></span>
                            {
                                'KPI设置：' + this.state.userName
                            }
                        </>:
                        'KPI设置：我的'
                } bordered={false}
                      className={'card-fixed-head-wrap'}
                      extra={
                          <>
                              {this.props.id ?
                                  <Button type={'primary'} style={{marginRight: '10px'}} danger
                                          onClick={this.setPeers}>设置360环评人员</Button>
                                  : ''
                              }
                              {
                                  this.state.ensure ?
                                      <Button type={'primary'} onClick={this.ensureKpi}>确认KPI</Button> : ''
                              }
                          </>

                      }
                >
                    <Spin spinning={loading}>
                        {
                            this.state.dataSource.length > 0 ?
                                <Collapse collapsible="header" defaultActiveKey={[periodId]}>
                                    {
                                        this.state.dataSource.map((item, index) => {
                                            return (
                                                <Panel forceRender header={item.periodName} key={item.periodId}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: 'flex-end',
                                                        marginBottom: "20px"
                                                    }}>
                                                        {
                                                            item.edit ?
                                                                <>
                                                                    <Tag style={{cursor: 'pointer'}}
                                                                         onClick={() => this.saveKpi(index)}
                                                                         color={'pink'}>保存草稿</Tag>
                                                                    <Tag style={{cursor: 'pointer'}}
                                                                         onClick={() => this.publishKpi(index)}
                                                                         color={'red'}>发布</Tag>
                                                                </> : ''
                                                        }
                                                        {
                                                            item.leaderEvaluate ?
                                                                <Tag style={{cursor: 'pointer'}}
                                                                     color={'green'}
                                                                     onClick={() => this.toPerformance(index, 'leader')}>评分</Tag> : ''
                                                        }
                                                        {
                                                            item.selfEvaluate ? <Tag color={'blue'}
                                                                                     style={{cursor: 'pointer'}}
                                                                                     onClick={() => this.toPerformance(index, 'self')}>自评</Tag> : ''
                                                        }
                                                    </div>
                                                    <Form initialValues={item}
                                                          disabled={!item.edit}
                                                          onValuesChange={(changedValues, allValues) => this.handlePushFilterValueChange(changedValues, allValues, index)}
                                                    >
                                                        <Form.Item hidden name='id'>
                                                            <input/>
                                                        </Form.Item>
                                                        <Form.List name='content'>
                                                            {
                                                                (fields, operation) => {
                                                                    return (
                                                                        <div>
                                                                            {(fields || []).map((field, index) => {
                                                                                return (
                                                                                    <div key={field.key}>
                                                                                        <Row align={'center'}
                                                                                             gutter={10}>
                                                                                            <Col span={17}>
                                                                                                <Form.Item
                                                                                                    labelCol={{flex: '56px'}}
                                                                                                    label={'kpi' + (index + 1)}
                                                                                                    name={[field.name, 'content']}>
                                                                                                    <Input/>
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                            <Col span={6}>
                                                                                                <Form.Item label="权重(%)"
                                                                                                           labelCol={{flex: '58px'}}
                                                                                                           name={[field.name, 'rate']}>
                                                                                                    <InputNumber min={1}
                                                                                                                 max={100}
                                                                                                                 step={1}/>
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                            <Col span={1}>
                                                                                                {
                                                                                                    item.edit ?
                                                                                                        <div
                                                                                                            className="close-filter"
                                                                                                            onClick={() => operation.remove(index)}>
                                                                                                            <Icon.MinusCircleOutlined/>
                                                                                                        </div>
                                                                                                        : ''
                                                                                                }
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                            <Form.Item>
                                                                                <Button type="dashed"
                                                                                        onClick={() => operation.add()}
                                                                                        block
                                                                                        icon={<Icon.PlusOutlined/>}>
                                                                                    添加KPI
                                                                                </Button>
                                                                            </Form.Item>
                                                                        </div>
                                                                    )
                                                                }
                                                            }
                                                        </Form.List>
                                                    </Form>

                                                </Panel>
                                            )
                                        })
                                    }
                                </Collapse>
                                :
                                <Empty/>
                        }

                    </Spin>
                </Card>
                <TransferModal ref={this.employeeModal} from={'employee'} handleCloseModal={(val) => console.log(val)}/>

            </>

        )
    }
}
export default withRouter(KpiDetail)